import OrderProductsSorterBuilder, {
  OrderProductsSorter,
  OrderProductsSorterSortParams,
} from './OrderProductsSorterBuilder';

class OrderProductsSorterDefault extends OrderProductsSorterBuilder {
  public sort<T extends OrderProductsSorter>({
    orderProducts,
  }: OrderProductsSorterSortParams<T>): T[] {
    return orderProducts;
  }
}

export default OrderProductsSorterDefault;
